import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

/** Vòng tiến độ nhỏ (SVG) — dùng ở thanh "Tiếp tục thiết lập" và mục "Bắt đầu" trên menu. */
export function ProgressRing({
  value,
  total,
  size = 28,
  stroke = 3,
  className,
  label = true,
  solid = false,
}: {
  value: number
  total: number
  size?: number
  stroke?: number
  className?: string
  /** Hiện chữ "x/y" ở giữa vòng. */
  label?: boolean
  /** Nền xanh đặc, vòng + chữ trắng (dùng cho lời nhắc cần nổi bật). */
  solid?: boolean
}) {
  const { t } = useTranslation('sharedMisc')
  const r = (size - stroke) / 2
  const c = 2 * Math.PI * r
  const ratio = total > 0 ? Math.min(1, Math.max(0, value / total)) : 0
  return (
    <span
      className={cn(
        'relative inline-flex shrink-0 items-center justify-center',
        solid && 'rounded-full bg-primary shadow-sm shadow-primary/40',
        className,
      )}
      style={{ width: size, height: size }}
      role="img"
      aria-label={t('progressRing.ariaLabel', { value, total })}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={stroke} className={solid ? 'stroke-white/30' : 'stroke-primary/15'} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={c * (1 - ratio)}
          className={cn(solid ? 'stroke-white' : 'stroke-primary', 'transition-[stroke-dashoffset] duration-500')}
        />
      </svg>
      {label && (
        <span className={cn('absolute text-[9px] font-semibold tabular-nums leading-none', solid ? 'text-white' : 'text-primary')}>
          {value}/{total}
        </span>
      )}
    </span>
  )
}
